import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import Reveal from "./Reveal";
import FeaturedProject from "./FeaturedProject";
import ProjectCard from "./ProjectCard";
import { projects } from "../data/portfolio";

gsap.registerPlugin(ScrollTrigger);

const featured = projects.find((p) => p.featured);
const rest = projects.filter((p) => !p.featured);

export default function Projects() {
  return (
    <section
      id="projects"
      style={{ padding: "7rem 3rem", maxWidth: 1200, margin: "0 auto" }}
    >
      <Reveal>
        <p
          style={{
            fontFamily: "var(--font-mono)",
            fontSize: "0.72rem",
            letterSpacing: "0.22em",
            color: "var(--accent)",
            textTransform: "uppercase",
            marginBottom: "1rem",
          }}
        >
            {/* 02. Projects */}  
        </p>
      </Reveal>

      <Reveal delay={0.05}>
        <h2
          style={{
            fontFamily: "var(--font-display)",
            fontSize: "clamp(3.5rem, 8vw, 7rem)",
            lineHeight: 0.88,
            marginBottom: "0.5rem",
          }}
        >
          WHAT I'VE
          <br />
          <span style={{ color: "var(--accent)" }}>BUILT.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <p
          style={{
            color: "var(--muted)",
            fontSize: "0.95rem",
            marginBottom: "4rem",
            fontFamily: "var(--font-mono)",
          }}
        >
          Production-grade apps. Real-world impact.
        </p>
      </Reveal>

      {/* Project grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "1px",
          background: "var(--border)",
        }}
        className="proj-grid"
      >
        {/* Featured spans full width */}
        <FeaturedProject project={featured} />

        {/* Rest of projects */}
        {rest.map((p, i) => (
          <ProjectCard key={p.id} project={p} index={i} />
        ))}
      </div>

      <style>{`
        @media (max-width: 768px) {
          .proj-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
